import { AuthorizationPayrollState } from './types';

const defaultAuthorizationPayrollState: AuthorizationPayrollState = {
  payrollList: null,
  payrollDetails: null,
  checkAuthorizationData: null,
  selectedPayroll: null,
  onSelectPayroll: () => {},
  onResetSelectedPayroll: () => {},
  loadingState: {
    isLoadingPayrollDetails: false,
    isLoadingCheckAuthorization: false,
  },
  errorState: {
    payrollDetailsError: undefined,
    checkAuthorizationError: undefined,
  },
  initiateMandateService: () => params => new Promise<any>(() => {}),
  executeMandateService: () => params => new Promise<any>(() => {}),
  onRefetchPayrollDetailsMutation: () => {},
  onCheckAuthorizationMutation: () => {},
  isAuthPayrollFlowDrawerOpen: false,
  onToggleAuthPayrollFlowDrawer: () => {},
};

export { defaultAuthorizationPayrollState };
